import {
    ITableListModel,
    TABLE_REQUEST_MODE,
    TableListRequestType,
    countData,
    deleteData,
    getData,
    patchData,
    postData,
} from '../utils/db'
import { parseQueryArguments, RoleType } from '@/shared'

/** How a user's tab is titled: "E. Member". */
export function userTabName(user: { firstName?: string; lastName?: string }) {
    let name = user.firstName ? user.firstName[0] + '.' : ''
    if (name && user.lastName) name += ' '
    if (user.lastName) name += user.lastName
    return name
}

export type TUser = {
    _id: string,
    userName: string,
    firstName: string,
    lastName: string,
    email: string,
    settings: object,
    role: RoleType,
}

export default class UserModel implements ITableListModel<TUser> {
    constructor() { }

    public async findtUserByNameOrEmail(nameOrEmail: string, id?: string) {
        let params = nameOrEmail
        if (id) params += `/${id}`
        return await getData(`/users/by-name-or-email/${params}`, { headers: { 'Cache-Control': 'no-cache' } }, true)
    }
    public async checkExistingUsernameOrEmail(nameOrEmail: string, id?: string) {
        let params = nameOrEmail
        if (id) params += `/${id}`
        return await getData(`/users/check-name-or-email/${params}`, { headers: { 'Cache-Control': 'no-cache' } }, true)
    }

    public async findProjectByName(projectName: string, id?: string) {
        let pn = projectName
        if (id) pn += `/${id}`
        return await getData(`/projects/by-name/${pn}`)
    }

    public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, page = 0, limit = 10, count, q = '' }: TableListRequestType) {
        // The lists pass the page size as count; reading limit alone left every
        // one of them at ten rows, with no way to the eleventh.
        let query = parseQueryArguments(`page=${page}&limit=${count ?? limit}`, arguments)
        if (q) query += '&q=' + encodeURI(q)
        if (mode == TABLE_REQUEST_MODE.POSITION) query += '&mode=position'

        return await getData(`/users?${query}`)
    }

    public async read(id: string) {
        return await getData(`/users/${id}`)
    }

    public async create(user: any) {
        return await postData('/users', user)
    }

    public async update(userId: string, data: any) {
        return await patchData(`/users/${userId}`, data)
    }

    public async updateSettings(userId: string, data: any) {
        return await patchData(`/users/${userId}/settings`, data)
    }

    public async delete(userId: string) {
        return await deleteData(`/users/${userId}`)
    }

    public async count() {
        return await countData(`/users/count`)
    }
}
